var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { Vue, Component, Watch } from "vue-facing-decorator";
import { AlarmsClient, SystemComponentsClient, SnapshotsClient, StringSnapshotClient, SystemSnapshotClient, SystemCommunicationsClient, SystemStatusClient, GetAlarmSummaryQuery, GetStringDetailDataQuery, GetSystemSnapshotCSVReportQuery, GetSystemSnapshotPDFReportQuery, GetAlarmViewPaginatedQuery, UpdateSystemSampleRateCommand, AlarmSummaryModel, SystemSnapshotModel, StringSnapshotModel, SystemComponentQueryModel, SystemSampleRateModel, PaginatedEnumerableOfAlarmQuery, ComponentTypeEnum, AlarmStatusEnum, AlarmSeverityEnum, MeasurementTypeEnum, MeasurementStatusModel, StringStatusEnum, SortDescription, SortDirection, BatteryTypeEnum, LithiumBatteryTypeEnum, LimitModel, LimitLayoutModel, ComponentStatusEnum } from "@/app/api/battery-portal-api";
import { defineAsyncComponent } from "vue";
// Eagerly start fetching the charts chunk at module load so it is available by the time chart data is populated on this immediate-render page.
const snapshotGraphPromise = import(/* webpackChunkName: "charts" */ "@/app/vues/charts/snapshot-graph.vue");
const snapshotGraphFilterPromise = import(/* webpackChunkName: "charts" */ "@/app/vues/charts/snapshot-graph-filter.vue");
const SnapshotGraphVue = defineAsyncComponent(() => snapshotGraphPromise);
const SnapshotGraphFilterVue = defineAsyncComponent(() => snapshotGraphFilterPromise);
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { ArrayHelper } from "@/app/utils/array-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
import RouteNames from "@/app/router/routes";
import LimitTooltipVue from "@/app/vues/components/limit-tooltip.vue";
import QueryStringHelper from "@/app/utils/querystring-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import moment from "moment";
import store from "@/app/store/store";
const alarmClient = new AlarmsClient(window.apiUrl);
const componentClient = new SystemComponentsClient(window.apiUrl);
const snapshotsClient = new SnapshotsClient(window.apiUrl);
const stringSnapshotClient = new StringSnapshotClient(window.apiUrl);
const systemSnapshotClient = new SystemSnapshotClient(window.apiUrl);
const systemCommunicationsClient = new SystemCommunicationsClient(window.apiUrl);
const systemStatusClient = new SystemStatusClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let StringSnapshotVue = class StringSnapshotVue extends Vue {
    constructor() {
        super(...arguments);
        this.measurementTypeEnum = MeasurementTypeEnum;
        // simpletons
        this.vueCreated = false;
        this.workingCount = 0;
        this.componentKey = 0;
        this.stringsLoaded = false;
        this.stringStatesLoaded = false;
        this.showSnapshot = true;
        this.editingSampleRate = false;
        this.retrievingAlarms = false;
        this.allStringsPlaceholder = "All Strings";
        this.sampleRatePopUp = "sample_rate_popup";
        this.currentView = ComponentTypeEnum.Controller;
        this.previousView = ComponentTypeEnum.Controller;
        this.previousStringId = 0;
        this.lastSnapshotTimestamp = null;
        this.exportPDFModalVisible = false;
        this.stringTabActive = 'graphs';
        this.snapshotDataCache = new Map();
        this.baseChartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            throttle: 100,
        };
        this.systemChartOptions = Object.assign(Object.assign({}, this.baseChartOptions), { plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    callbacks: {
                        title: (tooltipItem) => {
                            return `String ${tooltipItem[0].label}`.trim();
                        },
                        label: this.formatChartLabel
                    }
                }
            }, scales: {
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0
                    }
                }
            } });
        // models
        this.charts = new Array();
        this.stringTable = new Array();
        this.systemId = 0;
        this.controllerKeepAlive = false;
        this.hiddenCharts = new Array();
        this.string = new SystemComponentQueryModel();
        this.strings = new Array();
        this.snapshot = null;
        this.stringStates = new Array();
        this.systemSnapshot = new SystemSnapshotModel();
        this.stringSnapshot = new StringSnapshotModel();
        this.systemAxes = new Array();
        this.systemSampleRateModel = new SystemSampleRateModel();
        this.showAlarmsAfterSnapshotAlert = false;
        this.alarmQuery = new GetAlarmViewPaginatedQuery({
            companyId: null,
            systemId: null,
            siteId: null,
            alarmTypeId: null,
            alarmSeverityId: null,
            alarmStatusId: AlarmStatusEnum.ActiveUntilToDateTime,
            alarmSeverityIds: [AlarmSeverityEnum.Critical, AlarmSeverityEnum.Warning],
            stringStatusId: null,
            componentId: null,
            startTime: null,
            endTime: null,
            pageNo: 1,
            pageSize: 4,
            sort: new SortDescription({
                fieldName: "WhenRaised",
                direction: SortDirection.Descending
            })
        });
        this.alarmSummary = new AlarmSummaryModel();
        this.alarms = new PaginatedEnumerableOfAlarmQuery();
        this.controllerDataRequestTimestamp = null;
        this.moduleMeasurements = [MeasurementTypeEnum.CellTemperature, this.measurementTypeEnum.TerminalTemperature];
        // Export To Pdf Models
        this.stringsToExport = [];
        this.exportToPdfQuery = new GetSystemSnapshotPDFReportQuery({
            reportTimezoneOffSet: moment().utcOffset(),
            timezoneOffSet: moment().utcOffset(),
            systemId: null,
            measurementTime: null,
            alarms: true,
            limits: true,
            tables: true
        });
    }
    created() {
        this.vueCreated = true;
        window.addEventListener("resize", this.windowResizedEventHandler);
    }
    ;
    unmounted() {
        window.removeEventListener("resize", this.windowResizedEventHandler);
    }
    /**
     * Get available strings for selected system.
     * */
    setSystemStrings(systemStrings, selectedStringIdx) {
        this.strings = systemStrings;
        this.stringsLoaded = true;
        this.createStringsToExportArray();
        if (selectedStringIdx >= 0) {
            this.selectString(this.strings[selectedStringIdx]);
            return;
        }
        if (this.hasStrings)
            this.string = this.strings[0];
    }
    /**
     * Get alarm data (summary + list);
     * */
    getAlarms() {
        if (!this.systemId) {
            this.clearAlarms();
            return;
        }
        this.startWorking();
        var promises = [this.getAlarmSummary(),
            this.searchAlarms()];
        Promise.all(promises)
            .then(() => {
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.stopWorking();
        });
    }
    ;
    /**
     * Get alarm summary for selected system.
     * */
    getAlarmSummary() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.systemId)
                return;
            let summartQuery = new GetAlarmSummaryQuery({
                systemId: this.systemId,
                timestamp: this.snapshot ? DateHelper.convertToDate(this.snapshot.measurementTime.toString()) : null
            });
            return yield alarmClient
                .getAlarmSummary(summartQuery)
                .then(response => {
                this.alarmSummary = response;
                this.showAlarmsAfterSnapshotAlert = this.hasAlarmsAfterSnapshot;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            });
        });
    }
    ;
    /**
     * Search alarm records. Only interested in active alarms.
     * */
    searchAlarms() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.systemId)
                return;
            if (this.retrievingAlarms)
                return;
            this.retrievingAlarms = true;
            this.alarmQuery.systemId = this.systemId;
            this.alarmQuery.endTime = this.snapshot ? DateHelper.convertToDate(this.snapshot.measurementTime.toString()) : null;
            return yield alarmClient
                .search(this.alarmQuery)
                .then(response => {
                if (!response)
                    return;
                this.alarms = response;
                this.alarmQuery.pageNo = this.alarms.displayedPage == 0 ? 1 : this.alarms.displayedPage;
                this.alarmQuery.pageSize = this.alarms.pageSize;
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.setAlarmSummaryHeight();
                this.retrievingAlarms = false;
            });
        });
    }
    ;
    getAlarmState(alarm) {
        return alarm.whenCleared ? "Inactive" : "Active";
    }
    ;
    getAlarmValue(alarm) {
        var output = this.getValue(alarm.extremeValue == undefined ? null : alarm.extremeValue, alarm.digits || 2);
        if (alarm.uoM) {
            output += " " + alarm.uoM;
        }
        return output;
    }
    getValue(value, digits = 2) {
        return MeasurementHelper.getRoundedValueString(value, digits);
    }
    ;
    getVoltageValue(value) {
        return MeasurementHelper.formatVoltage(value);
    }
    ;
    getCurrentValue(value) {
        return MeasurementHelper.formatCurrent(value);
    }
    getSensorsRange(item) {
        var _a;
        if (((_a = item.moduleSensors) === null || _a === void 0 ? void 0 : _a.length) < 1)
            return "";
        return `${item.moduleSensors[0].componentCode} - ${item.moduleSensors[item.moduleSensors.length - 1].componentCode}`;
    }
    getSensorsCellTempRange(item) {
        var _a;
        if (((_a = item.moduleSensors) === null || _a === void 0 ? void 0 : _a.length) < 1)
            return "";
        return `${this.getValue(item.moduleSensors[0].cellTemperature, 1)} - ${this.getValue(item.moduleSensors[item.moduleSensors.length - 1].cellTemperature, 1)}`;
    }
    getSensorsTerminalTempRange(item) {
        var _a;
        if (((_a = item.moduleSensors) === null || _a === void 0 ? void 0 : _a.length) < 1)
            return "";
        return `${this.getValue(item.moduleSensors[0].terminalTemperature, 1)} - ${this.getValue(item.moduleSensors[item.moduleSensors.length - 1].terminalTemperature, 1)}`;
    }
    getAlarmCount(value) {
        return TextHelper.formatNumericStatusField(value || 0, 100);
    }
    ;
    getFirstOhmicReadingDate(systemComponent) {
        if (!systemComponent || !systemComponent.whenFirstOhmicReadingTaken)
            return ``;
        return DateHelper.convertToFriendlyMomentTimeString(systemComponent.whenFirstOhmicReadingTaken);
    }
    ;
    whenAlarmRaisedTimeString(alarm) {
        return DateHelper.convertToFriendlyMomentTimeString(alarm.whenRaised);
    }
    ;
    stringClass(string) {
        var stringState = this.stringStates.find(x => x.componentId == string.componentId);
        if (!stringState)
            return "";
        return `${stringState.componentStatusName}`.toLowerCase();
    }
    ;
    alarmClass(alarm) {
        if (alarm.alarmSeverityId == null)
            return "";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Critical)
            return "critical";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Warning)
            return "warning";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Info)
            return "info";
        return "";
    }
    ;
    measurementClass(measurementType) {
        const cssClass = "number";
        let measurement = this.measurementState(measurementType);
        if (!measurement)
            return cssClass;
        return `${cssClass} ${measurement.statusName || ""}`.trim().toLowerCase();
    }
    ;
    measurementState(measurementType, componentCode = null) {
        var _a, _b;
        const state = this.stringState();
        if (!state)
            return null;
        const measurementState = (_b = (_a = state.measurementStates) === null || _a === void 0 ? void 0 : _a.find(match => match.measurementTypeId == measurementType &&
            (componentCode == null || match.componentCode == componentCode))) !== null && _b !== void 0 ? _b : null;
        const isVoltageVariation = measurementType == MeasurementTypeEnum.BlockVoltageVariation ||
            measurementType == MeasurementTypeEnum.CellVoltageVariation;
        if ((measurementState === null || measurementState === void 0 ? void 0 : measurementState.limit) != null && this.isLithium && isVoltageVariation) {
            const src = measurementState.limit;
            const toUnit = (v) => (v != null ? v / 1000 : v);
            return Object.assign(new MeasurementStatusModel(), measurementState, {
                limit: Object.assign(Object.assign({}, src), { lowerCriticalLimit: toUnit(src.lowerCriticalLimit), lowerWarningLimit: toUnit(src.lowerWarningLimit), upperWarningLimit: toUnit(src.upperWarningLimit), upperCriticalLimit: toUnit(src.upperCriticalLimit) }),
            });
        }
        return measurementState;
    }
    stringState() {
        let status = this.stringStates.filter(match => match.componentId == this.string.componentId)[0];
        return status;
    }
    ;
    measurementClassByValue(measurementType, value) {
        const cssClass = "number";
        let measurement = this.measurementState(measurementType);
        if (!(measurement === null || measurement === void 0 ? void 0 : measurement.limit))
            return cssClass;
        if (measurementType == MeasurementTypeEnum.BlockVoltageVariation || measurementType == MeasurementTypeEnum.CellVoltageVariation)
            value = value / 1000;
        let currentState = "";
        if (measurement.limit.upperWarningLimit != null && value >= measurement.limit.upperWarningLimit)
            currentState = "warning";
        if (measurement.limit.upperCriticalLimit != null && value >= measurement.limit.upperCriticalLimit)
            currentState = "critical";
        if (measurement.limit.lowerWarningLimit != null && value <= measurement.limit.lowerWarningLimit)
            currentState = "warning";
        if (measurement.limit.lowerCriticalLimit != null && value <= measurement.limit.lowerCriticalLimit)
            currentState = "critical";
        return `${cssClass} ${currentState || ""}`.trim().toLowerCase();
    }
    createMeasurementForModuleVoltageVariation(item) {
        var model = new MeasurementStatusModel();
        model.limit = new LimitModel();
        model.limit.upperCriticalLimit = item.moduleVoltageVariationHighCrictialLimit;
        model.measurementTypeName = 'Lithium Module Voltage Variation';
        model.limit.layout = new LimitLayoutModel();
        model.limit.layout.showHighCritical = true;
        return model;
    }
    createMeasurementForModuleVoltageSense(item) {
        var model = new MeasurementStatusModel();
        model.limit = new LimitModel();
        model.limit.upperWarningLimit = item.moduleVoltageSenseHighWarningLimit;
        model.measurementTypeName = 'Lithium Module Voltage Sense Diff';
        model.limit.layout = new LimitLayoutModel();
        model.limit.layout.showHighWarning = true;
        return model;
    }
    createMeasurementForModuleBlock(item, measurementType) {
        var model = new MeasurementStatusModel();
        model.limit = new LimitModel();
        model.limit.layout = new LimitLayoutModel();
        try {
            switch (measurementType) {
                case MeasurementTypeEnum.BlockVoltage:
                    model.limit.upperCriticalLimit = item.voltageHighCriticalLimit;
                    model.limit.lowerCriticalLimit = item.voltageLowCriticalLimit;
                    model.measurementTypeName = this.isLithiumSamsungGen3 ? 'Cell Voltage' : 'Lithium Block Voltage';
                    break;
                case MeasurementTypeEnum.Temperature:
                    model.limit.upperCriticalLimit = item.temperatureHighCriticalLimit;
                    model.limit.lowerCriticalLimit = item.temperatureLowCriticalLimit;
                    model.limit.upperWarningLimit = item.temperatureHighWarningLimit;
                    model.limit.lowerWarningLimit = item.temperatureLowWarningLimit;
                    model.measurementTypeName = 'Lithium Block Temperature';
                    model.limit.layout.showHighWarning = true;
                    model.limit.layout.showLowWarning = true;
                    break;
                case MeasurementTypeEnum.CellTemperature:
                    model.limit.upperCriticalLimit = item.cellTempHighCriticalLimit;
                    model.limit.lowerCriticalLimit = item.cellTempLowCriticalLimit;
                    model.limit.upperWarningLimit = item.cellTempHighWarningLimit;
                    model.limit.lowerWarningLimit = item.cellTempLowWarningLimit;
                    model.measurementTypeName = 'Cell Temperature';
                    model.limit.layout.showHighWarning = true;
                    model.limit.layout.showLowWarning = true;
                    break;
                case MeasurementTypeEnum.TerminalTemperature:
                    model.limit.upperCriticalLimit = item.terminalTempHighCriticalLimit;
                    model.limit.upperWarningLimit = item.terminalTempHighWarningLimit;
                    model.measurementTypeName = 'Terminal Temperature';
                    model.limit.layout.showHighWarning = true;
                    break;
            }
            model.limit.layout.showHighCritical = true;
            model.limit.layout.showLowCritical = true;
        }
        catch (e) {
            console.error('createMeasurementForModuleBlock error', e);
        }
        return model;
    }
    measurementClassForMeasurementType(item, measurementType) {
        switch (measurementType) {
            case MeasurementTypeEnum.BlockVoltage:
                if (item.voltage == null || (item.voltageHighCriticalLimit == null && item.voltageLowCriticalLimit == null))
                    return "";
                if ((item.voltageLowCriticalLimit != null && item.voltage <= item.voltageLowCriticalLimit) || (item.voltageHighCriticalLimit != null && item.voltage >= item.voltageHighCriticalLimit))
                    return "critical";
                break;
            case MeasurementTypeEnum.Temperature:
                if (item.temperature == null || (item.temperatureHighCriticalLimit == null && item.temperatureLowCriticalLimit == null && item.temperatureHighWarningLimit == null && item.temperatureLowWarningLimit == null))
                    return "";
                if ((item.temperatureLowCriticalLimit != null && item.temperature <= item.temperatureLowCriticalLimit) || (item.temperatureHighCriticalLimit != null && item.temperature >= item.temperatureHighCriticalLimit))
                    return "critical";
                else if ((item.temperatureLowWarningLimit != null && item.temperature <= item.temperatureLowWarningLimit) || (item.temperatureHighWarningLimit != null && item.temperature >= item.temperatureHighWarningLimit))
                    return "warning";
                break;
            case MeasurementTypeEnum.CellTemperature:
                if (item.cellTemperature == null || (item.cellTempLowCriticalLimit == null && item.cellTempLowCriticalLimit == null && item.cellTempHighWarningLimit == null && item.cellTempLowWarningLimit == null))
                    return "";
                if ((item.cellTempLowCriticalLimit != null && item.cellTemperature <= item.cellTempLowCriticalLimit) || (item.cellTempHighCriticalLimit != null && item.cellTemperature >= item.cellTempHighCriticalLimit))
                    return "critical";
                else if ((item.cellTempLowWarningLimit != null && item.temperature <= item.cellTempLowWarningLimit) || (item.cellTempHighWarningLimit != null && item.cellTemperature >= item.cellTempHighWarningLimit))
                    return "warning";
                break;
            case MeasurementTypeEnum.TerminalTemperature:
                if (item.terminalTemperature == null || (item.terminalTempHighWarningLimit == null && item.terminalTempLowWarningLimit == null))
                    return "";
                if (item.terminalTempHighCriticalLimit != null && item.terminalTemperature >= item.terminalTempHighCriticalLimit)
                    return "critical";
                else if (item.terminalTempHighWarningLimit != null && item.terminalTemperature >= item.terminalTempHighWarningLimit)
                    return "warning";
                break;
        }
        return "";
    }
    getModuleRowClass(item) {
        var moduleRowClass = "";
        var assignModuleRowClass = function (measurementClass) {
            moduleRowClass = moduleRowClass == "critical" ? moduleRowClass : measurementClass == "critical" ? measurementClass : moduleRowClass || measurementClass;
        };
        assignModuleRowClass(this.getModuleVoltageVariationClass(item));
        assignModuleRowClass(this.getModuleVoltageSenseDiffClass(item));
        item.blocks.forEach((subitem) => {
            assignModuleRowClass(this.measurementClassForMeasurementType(subitem, MeasurementTypeEnum.BlockVoltage));
            assignModuleRowClass(this.measurementClassForMeasurementType(subitem, MeasurementTypeEnum.Temperature));
        });
        if (this.isLithiumSamsungGen3) {
            item.moduleSensors.forEach((subitem) => {
                assignModuleRowClass(this.measurementClassForMeasurementType(subitem, MeasurementTypeEnum.CellTemperature));
                assignModuleRowClass(this.measurementClassForMeasurementType(subitem, MeasurementTypeEnum.TerminalTemperature));
            });
        }
        return moduleRowClass;
    }
    getModuleVoltageVariationClass(item) {
        if (!(item === null || item === void 0 ? void 0 : item.blocks) || !item.voltageDelta || !(item === null || item === void 0 ? void 0 : item.moduleVoltageVariationHighCrictialLimit))
            return "";
        if (item.voltageDelta >= item.moduleVoltageVariationHighCrictialLimit)
            return "critical";
        return "";
    }
    getModuleVoltageSenseDiffClass(item) {
        if (!(item === null || item === void 0 ? void 0 : item.blocks) || !item.moduleVoltageSenseVariation || !(item === null || item === void 0 ? void 0 : item.moduleVoltageSenseHighWarningLimit))
            return "";
        if (item.moduleVoltageSenseVariation >= item.moduleVoltageSenseHighWarningLimit)
            return "warning";
        return "";
    }
    getStatusClass(statusId) {
        switch (statusId) {
            case ComponentStatusEnum.Critical:
                return "critical";
            case ComponentStatusEnum.Warning:
                return "warning";
        }
        return "";
    }
    getModuleBlocksClass(item) {
        if (!(item === null || item === void 0 ? void 0 : item.blocks))
            return "";
        var hasCritical = false;
        var hasWarning = false;
        item.blocks.forEach((block) => {
            var blockClass = this.getModuleBlockClass(block);
            hasCritical = hasCritical || blockClass == "critical";
            hasWarning = hasWarning || blockClass == "warning";
        });
        return hasCritical ? "critical" : hasWarning ? "warning" : "";
    }
    getModuleBlockClass(item) {
        if (!item.voltage || (!item.voltageHighCriticalLimit && !item.voltageLowCriticalLimit))
            return "";
        if ((item.voltageLowCriticalLimit != null && item.voltage <= item.voltageLowCriticalLimit) ||
            item.voltageHighCriticalLimit != null && item.voltage >= item.voltageHighCriticalLimit)
            return "critical";
        if (!item.temperature || (!item.temperatureHighCriticalLimit && !item.temperatureLowCriticalLimit && !item.temperatureHighWarningLimit && !item.temperatureLowWarningLimit))
            return "";
        if ((item.temperatureLowCriticalLimit != null && item.temperature <= item.temperatureLowCriticalLimit) ||
            item.temperatureHighCriticalLimit != null && item.temperature >= item.temperatureHighCriticalLimit)
            return "critical";
        if ((item.temperatureLowWarningLimit != null && item.temperature <= item.temperatureLowWarningLimit) ||
            item.temperatureHighWarningLimit != null && item.temperature >= item.temperatureHighWarningLimit)
            return "warning";
        return "";
    }
    getModuleSensorsClass(item) {
        if (!(item === null || item === void 0 ? void 0 : item.moduleSensors))
            return "";
        var hasCritical = false, hasWarning = false;
        item.moduleSensors.forEach((sensor) => {
            var sensorClass = this.getModuleSensorClass(sensor);
            hasCritical = hasCritical || sensorClass == "critical";
            hasWarning = hasWarning || sensorClass == "warning";
        });
        return hasCritical ? "critical" : hasWarning ? "warning" : "";
    }
    getModuleSensorClass(item) {
        var cellTempClass = this.measurementClassForMeasurementType(item, MeasurementTypeEnum.CellTemperature);
        var termTempClass = this.measurementClassForMeasurementType(item, MeasurementTypeEnum.TerminalTemperature);
        if (cellTempClass == "critical" || termTempClass == "critical")
            return "critical";
        if (cellTempClass == "warning" || termTempClass == "warning")
            return "warning";
        return "";
    }
    // set
    print() {
        window.print();
    }
    ;
    requestControllerData() {
        this.controllerDataRequestTimestamp = new Date();
    }
    ;
    selectString(item) {
        this.string = item;
        this.currentView = ComponentTypeEnum.String;
    }
    ;
    goToString(item) {
        let stringId = item.stringId;
        let string = this.strings.filter((match) => {
            return match.componentId == stringId;
        })[0];
        if (!string)
            return;
        this.selectString(string);
    }
    ;
    selectAllStrings() {
        queryStringHelper.updateQueryString(null, "stringId");
        this.currentView = ComponentTypeEnum.Controller;
    }
    ;
    showSampleRatePopUp() {
        systemCommunicationsClient
            .getSystemSampleRate(this.systemId)
            .then(response => {
            this.systemSampleRateModel = response;
            this.editingSampleRate = this.systemSampleRateModel != null ? true : false;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    saveSampleRate() {
        let model = this.systemSampleRateModel;
        model.whenUpdatedSampleRateConfiguration = new Date();
        let command = new UpdateSystemSampleRateCommand({
            requestModel: this.systemSampleRateModel
        });
        systemCommunicationsClient
            .updateSystemSampleRate(command, this.systemId.toString())
            .then(response => {
            Notifier.onOk("Sample rate has been successfully updated");
            this.systemSampleRateModel.whenUpdatedSampleRateConfiguration = model.whenUpdatedSampleRateConfiguration;
            this.editingSampleRate = false;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    cancelSampleRateChanges() {
        this.editingSampleRate = false;
    }
    ;
    changeSnapshotVisibility() {
        this.showSnapshot = !this.showSnapshot;
    }
    ;
    changeChartVisibility(index) {
        let idx = ArrayHelper.findFirstIndex(this.hiddenCharts, (item) => {
            return item == index;
        });
        if (idx < 0)
            this.hiddenCharts.push(index);
        else
            this.hiddenCharts.splice(idx, 1);
    }
    ;
    checkVisibility(index) {
        let idx = ArrayHelper.findFirstIndex(this.hiddenCharts, (item) => {
            return item == index;
        });
        return idx < 0 ? true : false;
    }
    ;
    constructSystemChartYAxes(chart) {
        return this.systemChartOptions;
    }
    ;
    constructStringChartYAxes(chart) {
        let chartOptions = Object.assign(Object.assign({}, this.baseChartOptions), { plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    callbacks: {
                        title: (tooltipItem) => {
                            var measurementTypeId = tooltipItem[0].dataset.measurementTypeId || 0;
                            if (this.isLithiumSamsungGen3Measurement(measurementTypeId)) {
                                return `Module ${tooltipItem[0].label} Sensor ${tooltipItem[0].dataset.datasetId}`;
                            }
                            else if (this.isLithium) {
                                return `Cell ${tooltipItem[0].label}`;
                            }
                            return `Block ${tooltipItem[0].label}`;
                        },
                        label: this.formatChartLabel
                    }
                },
            }, scales: {
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        autoSkip: true,
                        stepSize: 1,
                        maxRotation: 0,
                        minRotation: 0
                    }
                },
                xLimit: {
                    type: 'linear',
                    display: false,
                    grid: {
                        display: false
                    },
                    ticks: {
                        autoSkip: false,
                        stepSize: 0.5
                    },
                    //min: -0.5,
                    //max: 31.5,
                    offset: false
                },
                y: {
                    type: 'linear',
                    suggestedMin: 0,
                    suggestedMax: 0,
                    beginAtZero: false
                }
            }, onClick: this.onBarClick, onHover: (e, el) => {
                if (!e || !el || !el[0])
                    return;
                if (!this.isChartDrillDownAllowed)
                    return;
                let section = el[0];
                let currentStyle = e.native.target.style;
                currentStyle.cursor = section ? "pointer" : "normal";
            } });
        var axis = chartOptions.scales.y;
        if (chart.minValue) {
            axis.suggestedMin = chart.minValue;
        }
        if (chart.maxValue) {
            axis.suggestedMax = chart.maxValue;
        }
        return chartOptions;
    }
    ;
    onBarClick(event, elements) {
        var _a;
        if (!this.isChartDrillDownAllowed)
            return;
        if (!elements)
            return;
        let element = elements[0];
        if (!element || !((_a = event === null || event === void 0 ? void 0 : event.chart) === null || _a === void 0 ? void 0 : _a.data))
            return;
        let idx = element.index;
        let dataSetIdx = element.datasetIndex;
        let chart = event.chart;
        if (!chart.data.datasets || !chart.data.datasets.length)
            return;
        let dataSet = chart.data.datasets[dataSetIdx];
        if (!dataSet || !dataSet.ids || !dataSet.ids.length)
            return;
        let measurementTypeId = dataSet.measurementTypeId || 0;
        let blockId = dataSet.ids[idx] || 0;
        let params = {
            systemId: this.string.systemId.toString(),
            stringId: this.string.componentId.toString(),
            stringStatusId: this.string.stringStatusId ? this.string.stringStatusId.toString() : StringStatusEnum.Unknown.toString(),
            blockId: blockId.toString(),
            measurementTypeId: measurementTypeId.toString()
        };
        if (event.native.ctrlKey || event.native.metaKey) {
            const routeData = this.$router.resolve({
                name: RouteNames.TrendForMeasurement,
                params
            });
            window.open(routeData.href, '_blank');
        }
        else {
            // replace query to the router before navigating
            var measurementDate = null;
            if (queryStringHelper.hasParameter("measurementDate")) {
                const parameter = queryStringHelper.getParameter("measurementDate");
                if (parameter) {
                    measurementDate = DateHelper.convertToDate(parameter);
                }
            }
            var snapshotTime = null;
            if (queryStringHelper.hasParameter("snapshot")) {
                const parameter = queryStringHelper.getParameter("snapshot");
                if (parameter) {
                    snapshotTime = DateHelper.convertToDate(parameter);
                }
            }
            var stringId = null;
            if (queryStringHelper.hasParameter("stringId")) {
                const value = queryStringHelper.getParameter("stringId");
                if (value && parseInt(value)) {
                    stringId = parseInt(value);
                }
            }
            this.$router.replace({
                name: RouteNames.StringSnapshot,
                query: {
                    systemId: this.systemId,
                    measurementDate: measurementDate ? measurementDate.toISOString() : null,
                    snapshot: snapshotTime ? snapshotTime.toISOString() : null,
                    stringId: stringId ? stringId.toString() : null
                }
            });
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$router.push({
                        name: RouteNames.TrendForMeasurement,
                        params
                    });
                }, 1);
            });
        }
    }
    ;
    clearAlarms() {
        this.alarmSummary = new AlarmSummaryModel();
        this.alarms = new PaginatedEnumerableOfAlarmQuery({
            displayedPage: 1,
            pageSize: 0,
            recordCount: 0,
            records: []
        });
        this.setAlarmSummaryHeight();
    }
    ;
    matchingSnapshots(item) {
        let snapshot = this.snapshot;
        if (!snapshot || !snapshot.stringSnapshots)
            return new Array();
        let result = snapshot.stringSnapshots.filter((match) => {
            return match.stringId === item.componentId;
        });
        if (!result.length)
            result.push(new StringSnapshotModel());
        //let status = this.stringStates.filter(match => match.componentId == item.componentId)[0]
        //if (status) {
        //	result.forEach(item => {
        //		item.statusId = status.stringStatusId;
        //		item.stringStatusId = status.stringStatusId;
        //		item.status = status.componentStatusName;
        //		item.stringStatus = status.stringStatusName;
        //	})
        //}
        return result;
    }
    ;
    expandAllStringTableClick() {
        var expanded = this.stringTableAllExpanded;
        this.stringTable.forEach(item => item.expanded = !expanded);
    }
    windowResizedEventHandler() {
        let timer = null;
        if (timer)
            window.clearTimeout(timer);
        timer = window.setTimeout(this.setAlarmSummaryHeight, 100);
    }
    ;
    setAlarmSummaryHeight() {
        let alarmStatusWrapper = document.getElementById("snapshot-alarm-status-wrapper");
        let alarmListWrapper = document.getElementById("snapshot-alarm-list-wrapper");
        if (!alarmStatusWrapper || !alarmListWrapper)
            return;
        let height = alarmListWrapper.offsetHeight;
        if (height <= 0)
            return;
        alarmStatusWrapper.style.height = `${height}px`;
    }
    ;
    get stringPanelClass() {
        let panelClass = "string-panel col-xs-12";
        if (!this.strings)
            return panelClass;
        if (this.strings.length <= 1)
            return `${panelClass} col-sm-12`;
        if (this.strings.length <= 2)
            return `${panelClass} col-sm-6 col-md-6`;
        if (this.strings.length <= 3)
            return `${panelClass} col-sm-6 col-md-4`;
        return `${panelClass} col-sm-6 col-md-3`;
    }
    ;
    get isLithium() {
        var _a;
        return ((_a = this.snapshot) === null || _a === void 0 ? void 0 : _a.batteryType) == BatteryTypeEnum.Lithium;
    }
    ;
    get isLithiumSamsungGen3() {
        var _a;
        return this.isLithium && ((_a = this.snapshot) === null || _a === void 0 ? void 0 : _a.lithiumBatteryType) == LithiumBatteryTypeEnum.SamsungGen3;
    }
    ;
    isLithiumSamsungGen3Measurement(measurementType) {
        return this.isLithiumSamsungGen3 && this.moduleMeasurements.includes(measurementType);
    }
    ;
    get hasStrings() {
        return this.strings && this.strings.length ? true : false;
        ;
    }
    ;
    get componentTitle() {
        if (this.showAllStrings)
            return this.allStringsPlaceholder;
        return this.string ? (this.string.componentName || `${this.string.componentId}`) : "Please select a string";
    }
    ;
    get showAllStrings() {
        return this.currentView == ComponentTypeEnum.Controller;
    }
    ;
    get selectedString() {
        return this.showAllStrings ? null : this.string;
    }
    ;
    get hasAlarmsAfterSnapshot() {
        if (!this.controllerKeepAlive)
            return false;
        if (!this.alarmSummary)
            return false;
        return this.alarmSummary.numberOfAlarmsActiveAfterSnapshotTimestamp && this.alarmSummary.isLatestSnapshotTimestamp ? true : false;
    }
    ;
    get isBusy() {
        if (this.working)
            return true;
        if (!this.stringsLoaded)
            return true;
        return false;
    }
    ;
    get stringTableAllExpanded() {
        return !this.stringTable.find(item => item.expanded == false);
    }
    getSnapshotDataCacheKey(measurementTime, stringIdx) {
        var snapshotId = measurementTime ? DateHelper.convertToDate(measurementTime.toString()).getTime() : "";
        return `${snapshotId}_${stringIdx}`;
    }
    clearSnapshot(clearStrings) {
        this.snapshot = null;
        // reset view to controller when the selected system is changed.
        this.currentView = ComponentTypeEnum.Controller;
        this.charts = new Array();
        if (clearStrings) {
            this.string = new SystemComponentQueryModel();
            this.strings = [];
        }
        this.clearAlarms();
        // reset string table
        this.stringTabActive = 'graphs';
        this.stringTable = new Array();
    }
    // observables & events
    onSystemSelectedEvent(systemId, data, lastSnapshotTimestamp, controllerKeepAlive) {
        var _a;
        this.lastSnapshotTimestamp = lastSnapshotTimestamp;
        this.systemId = systemId;
        this.controllerKeepAlive = controllerKeepAlive;
        this.clearSnapshot(true);
        this.snapshotDataCache.clear();
        if (!data)
            return;
        this.snapshotDataCache.set(this.getSnapshotDataCacheKey((_a = data.selectedSnapshot) === null || _a === void 0 ? void 0 : _a.measurementTime, data.stringIdx), data);
        this.setSystemStrings(data.strings, data.stringIdx);
    }
    ;
    getCachedSnapshotData() {
        var _a, _b, _c;
        if (!((_a = this.snapshot) === null || _a === void 0 ? void 0 : _a.measurementTime))
            return;
        if (this.currentView != this.previousView || this.string.componentId != this.previousStringId) {
            this.charts = new Array();
        }
        var stringIdx = this.showAllStrings ? -1 : this.strings.findIndex(item => item.componentId == this.string.componentId);
        var data = this.snapshotDataCache.get(this.getSnapshotDataCacheKey((_b = this.snapshot) === null || _b === void 0 ? void 0 : _b.measurementTime, stringIdx));
        if (!data) {
            var query = new GetStringDetailDataQuery({
                systemId: this.systemId,
                stringId: (_c = this.selectedString) === null || _c === void 0 ? void 0 : _c.componentId,
                measurementTime: this.snapshot.measurementTime
            });
            this.startWorking();
            snapshotsClient.getStringDetail(query)
                .then(response => {
                var _a;
                if (response) {
                    this.snapshotDataCache.set(this.getSnapshotDataCacheKey((_a = this.snapshot) === null || _a === void 0 ? void 0 : _a.measurementTime, stringIdx), response);
                    this.assignSnapshotData(response);
                }
                else {
                    Notifier.onError("Could not retrieve snapshot data.");
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.previousView = this.currentView;
                this.previousStringId = this.string.componentId;
                this.stopWorking();
            });
        }
        else {
            this.assignSnapshotData(data);
        }
    }
    assignSnapshotData(data) {
        var _a, _b;
        // String States
        this.stringStates = data.stringStates || [];
        for (var i = 0; i < this.stringStates.length; i++) {
            let status = this.stringStates[i];
            let string = (_a = this.strings) === null || _a === void 0 ? void 0 : _a.filter((match) => {
                return match.componentId == status.componentId;
            })[0];
            if (string) {
                string.statusId = status.stringStatusId;
                string.stringStatusId = status.stringStatusId;
                string.componentStatusName = (_b = status.componentStatusName) !== null && _b !== void 0 ? _b : string.componentStatusName;
                string.stringStatusName = status.stringStatusName;
            }
        }
        this.stringStatesLoaded = true;
        // Charts
        let chartsToDisplay = data.charts || [];
        if (this.showAllStrings && chartsToDisplay.length)
            chartsToDisplay = chartsToDisplay.slice(4, chartsToDisplay.length);
        this.charts = chartsToDisplay;
        this.stringTable = data.tableData || [];
        this.updateCharts();
    }
    //busyByEvent: boolean = false;
    onBusyEvent(isBusy) {
        //if (!isBusy && !this.busyByEvent) return;
        //this.busyByEvent = isBusy;
        if (isBusy) {
            this.startWorking();
        }
        else {
            this.stopWorking();
        }
    }
    ;
    get working() {
        return this.workingCount > 0;
    }
    startWorking() {
        this.workingCount++;
    }
    stopWorking() {
        if (this.workingCount > 0) {
            this.workingCount--;
        }
    }
    onStringSnapshotSelectedEvent(snapshot, data) {
        var _a;
        this.snapshot = snapshot;
        if (!snapshot) {
            this.clearSnapshot(false);
            return;
        }
        this.snapshotDataCache.clear();
        if (data) {
            this.snapshotDataCache.set(this.getSnapshotDataCacheKey((_a = data.selectedSnapshot) === null || _a === void 0 ? void 0 : _a.measurementTime, data.stringIdx), data);
        }
        this.updateStringSnapshot();
        this.getAlarms();
        this.snapshot.stringSnapshots.forEach(item => {
            let status = this.stringStates.filter(match => item.stringId == match.componentId)[0];
            if (status) {
                item.statusId = status.stringStatusId;
                item.stringStatusId = status.stringStatusId;
                item.status = status.componentStatusName;
                item.stringStatus = status.stringStatusName;
            }
        });
    }
    ;
    onStringSnapshotNotFound() {
        this.snapshot = null;
        this.clearSnapshot(false);
        this.updateStringSnapshot();
    }
    ;
    updateStringSnapshot() {
        let systemSnapshot = new SystemSnapshotModel();
        if (!this.snapshot) {
            this.systemSnapshot = systemSnapshot;
        }
        else {
            this.systemSnapshot = this.snapshot.systemSnapshot || systemSnapshot;
        }
        if (this.showAllStrings) {
            queryStringHelper.updateQueryString(null, "stringId");
            this.getCachedSnapshotData();
            return;
        }
        let stringSnapshot = new StringSnapshotModel();
        stringSnapshot.init({});
        if (!this.snapshot) {
            this.stringSnapshot = stringSnapshot;
        }
        else {
            this.stringSnapshot = (this.snapshot.stringSnapshots || []).filter(item => {
                return item.stringId == this.string.componentId;
            })[0] || stringSnapshot;
        }
        queryStringHelper.updateQueryString(this.stringSnapshot ? this.stringSnapshot.stringId : null, "stringId");
        this.getCachedSnapshotData();
    }
    ;
    updateDisplayedCharts() {
        if (this.showAllStrings) {
            this.getCachedSnapshotData();
            return;
        }
        this.updateStringSnapshot();
    }
    ;
    exportToCSV() {
        if (this.working)
            return;
        if (!this.string.systemId || !this.snapshot) {
            Notifier.onWarning("Please select a system and a snapshot before downloading the report.");
            return;
        }
        let reportQuery = new GetSystemSnapshotCSVReportQuery({
            timezoneOffSet: moment(this.snapshot.measurementTime).utcOffset(),
            currentTimezoneOffSet: moment().utcOffset(),
            systemId: this.systemId,
            measurementTime: DateHelper.convertToDate(this.snapshot.measurementTime.toString())
        });
        systemSnapshotClient.downloadSystemSnapshotAsCsv(reportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download snapshot data.");
                return;
            }
            DownloadUtil.handleFileDownload(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    // Export To Pdf Methods
    showExportToPdfModal() {
        if (this.working)
            return;
        if (!this.string.systemId || !this.snapshot) {
            Notifier.onWarning("Please select a system and a snapshot before downloading the report.");
            return;
        }
        this.exportPDFModalVisible = true;
    }
    exportToPdf() {
        if (this.numberOfSelectedStringToExport <= 0) {
            Notifier.onWarning("Please select at least one string.");
            return;
        }
        if (!this.snapshot)
            return;
        this.exportPDFModalVisible = false;
        this.startWorking();
        var stringIds = this.stringsToExport.filter(string => string.selected).map(string => string.value);
        let reportQuery = new GetSystemSnapshotPDFReportQuery(Object.assign(Object.assign({}, this.exportToPdfQuery), { reportTimezoneOffSet: moment().utcOffset(), timezoneOffSet: moment(this.snapshot.measurementTime).utcOffset(), systemId: this.systemId, measurementTime: DateHelper.convertToDate(this.snapshot.measurementTime.toString()), stringIds: stringIds }));
        systemSnapshotClient.downloadSystemSnapshotAsPdf(reportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download snapshot data.");
                return;
            }
            //DownloadUtil.handleFileDownload(response);
            let blob = new Blob([response.data], { type: 'application/pdf;base64' });
            let url = URL.createObjectURL(blob);
            var popUp = window.open(url, '_blank');
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Please disable your pop-up blocker and try again.');
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.stopWorking();
        });
    }
    ;
    createStringsToExportArray() {
        let stringsToExport = (this.strings || []).map((item) => {
            return {
                value: item.componentId,
                text: item.componentName || "",
                selected: true
            };
        });
        this.stringsToExport = stringsToExport;
    }
    ;
    selectReportString(stringItem) {
        stringItem.selected = !stringItem.selected;
    }
    ;
    getDateTimeFormatted(date) {
        return moment(date).format("DD MMM YYYY, HH:mm a");
    }
    get numberOfSelectedStringToExport() {
        return this.stringsToExport.filter(string => string.selected).length;
    }
    ;
    get stringToExportOptionText() {
        var _a;
        if (this.numberOfSelectedStringToExport == this.stringsToExport.length)
            return `All strings`;
        if (this.numberOfSelectedStringToExport != 1)
            return `${this.stringsToExport.filter(string => string.selected).length} strings selected`;
        return (_a = this.stringsToExport.filter(string => string.selected)[0]) === null || _a === void 0 ? void 0 : _a.text;
    }
    ;
    getComponentKey(index) {
        return this.componentKey + 999 + index;
    }
    updateCharts() {
        this.componentKey++;
    }
    formatChartLabel(tooltipItem) {
        let label = tooltipItem.dataset.label || '';
        if (label) {
            label += ': ';
        }
        if (tooltipItem.parsed.y !== null) {
            var formattedValue = MeasurementHelper.getFormattedValueForUnitOfMeasurement(tooltipItem.parsed.y, tooltipItem.dataset.measurementTypeId);
            label += formattedValue;
        }
        return label;
    }
    get isStandardOrHigher() {
        return store.getters["licenseModule/isStandardOrHigher"];
    }
    // Drill-down from snapshot graphs to trend page. Lithium requires Standard or above;
    // lead-acid (and other non-lithium chemistries) are unrestricted.
    get isChartDrillDownAllowed() {
        if (!this.isLithium)
            return true;
        return this.isStandardOrHigher;
    }
};
__decorate([
    Watch("alarmQuery.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], StringSnapshotVue.prototype, "searchAlarms", null);
__decorate([
    Watch("string"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StringSnapshotVue.prototype, "updateStringSnapshot", null);
__decorate([
    Watch("showAllStrings"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StringSnapshotVue.prototype, "updateDisplayedCharts", null);
StringSnapshotVue = __decorate([
    Component({
        name: "StringSnapshotVue",
        components: {
            SnapshotGraphVue,
            SnapshotGraphFilterVue,
            LimitTooltipVue
        }
    })
], StringSnapshotVue);
export default StringSnapshotVue;
